import { IJsonQuery, IJsonQueryPolygon } from '@cian/api-models/common/json_query';

import { IPolygon } from '../../types/map/polygon';
import { toPolygon } from './toPolygon';

export function preparePolygons(jsonQuery: IJsonQuery): IPolygon[] {
  const geoValue = jsonQuery.geo?.value || [];
  const jsonQueryPolygons = geoValue.filter(({ type }) => type === 'polygon') as IJsonQueryPolygon[];
  const polygons = jsonQueryPolygons.map(toPolygon);

  return polygons;
}
